import React from "react";
import { RatingInfoContent } from "./RatingInfoContent";

const AttitudeRatingInfo = () => <RatingInfoContent dimension="attitude" />;

export { AttitudeRatingInfo };
export default AttitudeRatingInfo;
